import {
  BillStatus,
  FoodType,
  InternalBillType,
  KITCHEN_COOKING,
  KITCHEN_READY,
  OfferType,
  PayMedium,
  SEND_TO_KITCHEN,
  Spicy,
  TRIP_ASSIGNED,
  TRIP_DELIVERED
} from "../../../constants/constant";

export const INITIAL_SNP_COMPONENT = {
  outSideClickDismiss: true,
  title: "",
  subTitle: "",
  negativeAction: "",
  positiveAction: "",
  positiveReq: false,
  iconReq: false,
  iconContent: "",
  snackBarOpen: false,
  snackBarMsg: "",
  cancelExtra: false,
  negativeReq: false,
  requestType: 0,
  gui: "",
  snackVertical: "",
  snackHorizontal: "",
  snackColor: "",
};

//const [gstFeature, setGstFeature] = useState(false);

export const INITIAL_BILL_STOCK_DATA = {
  prdId: "",
  name: "",
  sgst: 0,
  cgst: 0,
  price: 0.0,
  actualPrice: 0.0,
  selectedUnit: "",
  conversionTypeId: "",
  conversionType: null,
  unitPrice: 0.0,
  smallUnitPrice: 0.0,
  foodQuantityName: "",
  priceIndex: 0,
  finalprice: 0.0,
  note: "",
  savedQuantity: 1,
  quantity: 1,
  offerDenom: 0,
  offerAmt: 0.0,
  print: false,
  combo: false,
};
export const INITIAL_STOCK_DATA = {
  id: "",
  catgId: "",
  catgName: "",
  name: "",
  productImage: [],
  ingredients: "",
  spicy: Spicy.LESS_SPICY,
  foodType: FoodType.VEG,
  sgst: 0.0,
  cgst: 0.0,
  outOfStock: false,
  offertype: OfferType.No_Offer,
  offerAmt: 0.0,
  price: [],
  liveStockCount: "",
  unitCount: 0.0,
  smallUnitCount: 0.0,
  unitRestrictions: 0.0,
};
export const INITIAL_BILL_DETAILS = {
  subTotal: 0.0,
  cgst: 0.0,
  cgstAmt: 0.0,
  sgstAmt: 0.0,
  sgst: 0.0,
  isGstAllowed: true,
  roundOff: 0.0,
  cashTender: 0.0,
  cashReturn: 0.0,
  pointRedeem: 0.0,
  isPointAdded: false,
  total: 0.0,
  currDues: 0.0,
  pendingAmt: 0.0,
  offerDenom: OfferType.No_Offer,
  offerAmt: 0.0,
  billingType: InternalBillType.TakeAway,
  lapsedTime: 0,
  lpatialAmt: [],
  token: -1,
};



export const INITIALROOMDETAIS = {
  roomNo: "",
  roomBooked: false,
  hotelBillId: "",
  custName: "",
  saved: false,
  mobNo: "",
  emailId: "",
  address: "",
};
export const INITIAL_RIDER_DETAILS = {
  id: "",
  name: "",
};

export const INITIAL_LISTBILLINGDATA = {
  billNo: "",
  value_2: [],
  delItems: [],
  custId: "",
  custMob: "",
  custName: "",
  custEmail: "",
  address: "",
  custGstDetails: "",
  custCompanyName: "",
  billStatus: BillStatus.NO_ENTRY,
  pointRedeem: 0,
  token: 0,
  roundOff: 0.0,
  kot: 0,
  hotelBillId: "",
  hotelBillNo: "",
  homeDelvId: "",
  homeDelvOtp: "",
  generateOtp: "",
  onlineBillOtherName: "",
  settleDown: false,
  payLaterSignal: false,
  // createdAt: toda,
  tripUpdateReq: false,
  tripStatus: "",
  pTripStatus: "",
  assignedBy: "",
  assignedByName: "",
  riderId: "",
  riderIdName: "",
  transactionId: "",
  payAtCounterOpt: false,
  kotCopies: 1,
};

export const INITIAL_PAYMENT_DETAILS = {
  onlinePayThrough: "",
  onlinePayMedium: "",
  cashPayThrough: "",
  onlinePay: 0.0,
  cashPay: 0.0,
  cashTender: 0.0,
  cashReturn: 0.0,
  delvName: "",
  payMedium: PayMedium.NOPAY,
};

export const INITIAL_DEL_ITEM = {
  showDialog: false,
  prdId: "",
  delReason: "",
  prdName: "",
};
export const INITIAL_GENERATE_DIALOG = {
  showDialog: false,
  otp: "",
};


export const TRIP_STATUS = [
  SEND_TO_KITCHEN,
  KITCHEN_COOKING,
  KITCHEN_READY,
  TRIP_ASSIGNED,
  TRIP_DELIVERED,
];

export const TRIP_STATUS_BACK = [
  {
    no: 1,
    name: SEND_TO_KITCHEN,
  },
  {
    no: 2,
    name: KITCHEN_COOKING,
  },
  {
    no: 3,
    name: KITCHEN_READY,
  },
  {
    no: 4,
    name: TRIP_ASSIGNED,
  },
  {
    no: 6,
    name: TRIP_DELIVERED,
  },
];

export const INITIAL_PARTIAL_PAY = {
  id: "",
  partialAmt: 0.0,
  onlineBillPaidThrough: "",
  isOnlinePayEnabled: false,
  isCashPayEnabled: false,
  onlinePayMedium: "",
  onlinePay: 0.0,
  cashBillPaidThrough: "",
  cashPay: 0.0,
  paidAcceptBy: "",
  paidOn: "",
  cashTendered: 0.0,
  cashReturn: 0.0,
};


//Changes Realetd to keyboard bill
export const INITIAL_CUSTOMER_DATA = {
  custId: "",
  custMob: "",
  associateId: "",
  custName: "",
  custEmail: "",
  address: "",
  custGstDetails: "",
  custCompanyName: "",
  assosiateAvailable: false,
  useAssociateBenefit: false,
};

export const INITIAL_PAYMENT_MODEL = {
  onlinePayMedium: "",
  onlinePayThrough: "",
  cashPayThrough: "",
  onlinePay: 0.0,
  cashPay: 0.0,
  finalPrice: 0.0, //This is total
  cgstAmt: 0.0,
  sgstAmt: 0.0,
  isGstAllowed: true,
  roundOff: 0.0,
  totalPrice: 0.0, //This is subTotal
  cgst: 0.0,
  sgst: 0.0,
  takenDenom: OfferType.No_Offer,
  takenOffrAmt: 0.0,
  cashTender: 0.0,
  cashReturn: 0.0,
  payMedium: PayMedium.NOPAY,
  delvName: "",
  delvCharge: 0.0,
};

export const INITIAL_BILL_UTILS = {
  tableId: "",
  tableNo: 0,
  billNo: "",
  tableName: "",
  billType: InternalBillType.TakeAway,
};

export const INITIAL_EXTERNAL_MAP = {
  payAtCounterOpt: false,
  hotelBillId: "",
  hotelBillNo: "", //roomNo
  homeDelvOtp: "",
  homeDelvId: "",
  payLaterSignal: false,
  roomBooked: false,
  saved: false,
  transactionId: "",
  mobNo: "",
  emailId: "",
  address: "",
};

export const INITIAL_TRIP_DETAILS = {
  pTripStatus: "",
  tripStatus: "",
  tripUpdateReq: false,
  assignedBy: "",
  assignedByName: "",
  riderId: "",
  riderIdName: "",
};

export const INITIAL_REFERENCE_BILL_DETAILS = {
  referenceBillId: "",
  refAvailable: false,
  referenceBillNo: "",
  referenceBillItems: [],
};

export const INITIAL_POINT_DETAILS = {
  isPointAdded: false,
  pointRedeem: 0.0,
  redeemRoyaltyPrice: false,
};

export const INITIAL_ITEM_DIALOG = {
  action: -1, //0 for Notes 1 for delete 2 for gen Bill 3 for Previous Kot
  dialogMsg: "",
  itemName: "",
  itemId: "",
};
